<template>
  <v-form class="pa-6">
    <h3 class="text-left mb-1 text-primary">Config Manager</h3>
    <p class="text-caption mb-4">Configurá y generá los tokens de generación y uso de Alison Server.</p>

    <h4 class="text-left mb-2">Variables</h4>
    <v-row>
      <v-col md="4">
        <v-text-field
          v-model="serverURL"
          label="server URL"
        ></v-text-field>
        <v-text-field
          v-model="seat"
          label="Seat"
        ></v-text-field>
        <v-text-field
          v-model="tenant"
          label="Tenant"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <h4 class="mb-2">Generation <span v-if="existsGenerationToken">(generated)</span></h4>
    <div class="d-flex ga-2 mb-4">
      <v-btn
        size="small"
        :disabled="generationGrantType == '' || generationClientId == '' || generationClientSecret == ''"
        color="primary"
        @click="updateGenerationToken">
        Generation >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-text-field
          v-model="generationClientId"
          label="Client id"
        ></v-text-field>
        <v-text-field
          v-model="generationClientSecret"
          label="Client secret"
          type="password"
        ></v-text-field>
        <v-text-field
          v-model="generationGrantType"
          label="Grant Type"
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <div v-if="steps.generation.length === 0" class="text-caption text-medium-emphasis">
          Ejecutá "Generation >>" para ver el progreso
        </div>
        <template v-for="step in steps.generation" :key="step.key">
          <div class="d-flex align-center mb-2">
            <v-progress-circular
              v-if="step.status === 'loading'"
              indeterminate
              size="16"
              width="2"
              color="primary"
              class="mr-2"
            ></v-progress-circular>
            <v-icon v-else-if="step.status === 'success'" color="green" size="18" class="mr-2">mdi-check-circle</v-icon>
            <v-icon v-else-if="step.status === 'error'" color="red" size="18" class="mr-2">mdi-close-circle</v-icon>
            <v-icon v-else-if="step.status === 'warning'" color="amber-darken-2" size="18" class="mr-2">mdi-alert-circle</v-icon>
            <v-icon v-else color="grey-lighten-1" size="18" class="mr-2">mdi-circle-outline</v-icon>
            <span :class="{'text-red': step.status === 'error', 'text-amber-darken-3': step.status === 'warning'}">
              {{ (step.status === 'error' || step.status === 'warning') && step.message ? step.message : step.label }}
            </span>
          </div>
          <vue-json-pretty v-if="step.key === 'decode' && step.payload" :data="step.payload" class="mb-3"></vue-json-pretty>
        </template>

        <div v-if="steps.generation.length" class="mt-2">
          <a href="#" class="text-caption" @click.prevent="showConsole.generation = !showConsole.generation">
            {{ showConsole.generation ? 'Ocultar consola' : 'Ver consola' }}
          </a>
        </div>
        <div v-if="showConsole.generation" class="console-panel mt-2">
          <div v-for="(entry, idx) in logs.generation" :key="idx" class="mb-3">
            <div class="text-caption text-medium-emphasis">
              [{{ entry.time }}] {{ logLine(entry) }}
            </div>
            <vue-json-pretty :data="entry.body"></vue-json-pretty>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <h4 class="mb-2">Usage <span v-if="existsUsageToken">(generated)</span></h4>
    <div class="d-flex ga-2 mb-4">
      <v-btn
        size="small"
        :disabled="usageGrantType == '' || usageClientId == '' || usageClientSecret == ''"
        color="primary"
        @click="updateUsageToken">
        USAGE >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-text-field
          v-model="usageClientId"
          label="Client id"
        ></v-text-field>
        <v-text-field
          v-model="usageClientSecret"
          label="Client secret"
          type="password"
        ></v-text-field>
        <v-text-field
          v-model="usageGrantType"
          label="Grant Type"
        ></v-text-field>
        <v-text-field
          v-model="usageScope"
          label="Scope"
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <div v-if="steps.usage.length === 0" class="text-caption text-medium-emphasis">
          Ejecutá "USAGE >>" para ver el progreso
        </div>
        <template v-for="step in steps.usage" :key="step.key">
          <div class="d-flex align-center mb-2">
            <v-progress-circular
              v-if="step.status === 'loading'"
              indeterminate
              size="16"
              width="2"
              color="primary"
              class="mr-2"
            ></v-progress-circular>
            <v-icon v-else-if="step.status === 'success'" color="green" size="18" class="mr-2">mdi-check-circle</v-icon>
            <v-icon v-else-if="step.status === 'error'" color="red" size="18" class="mr-2">mdi-close-circle</v-icon>
            <v-icon v-else-if="step.status === 'warning'" color="amber-darken-2" size="18" class="mr-2">mdi-alert-circle</v-icon>
            <v-icon v-else color="grey-lighten-1" size="18" class="mr-2">mdi-circle-outline</v-icon>
            <span :class="{'text-red': step.status === 'error', 'text-amber-darken-3': step.status === 'warning'}">
              {{ (step.status === 'error' || step.status === 'warning') && step.message ? step.message : step.label }}
            </span>
          </div>
          <vue-json-pretty v-if="step.key === 'decode' && step.payload" :data="step.payload" class="mb-3"></vue-json-pretty>
        </template>

        <div v-if="steps.usage.length" class="mt-2">
          <a href="#" class="text-caption" @click.prevent="showConsole.usage = !showConsole.usage">
            {{ showConsole.usage ? 'Ocultar consola' : 'Ver consola' }}
          </a>
        </div>
        <div v-if="showConsole.usage" class="console-panel mt-2">
          <div v-for="(entry, idx) in logs.usage" :key="idx" class="mb-3">
            <div class="text-caption text-medium-emphasis">
              [{{ entry.time }}] {{ logLine(entry) }}
            </div>
            <vue-json-pretty :data="entry.body"></vue-json-pretty>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import enviroment from '../enviroment.js';
import alisonServer from  '../services/alisonServer.js';
import VueJsonPretty from 'vue-json-pretty';
  export default {
    props:["data", "config", "serverConfig"],
    components: {
      VueJsonPretty
    },
    data: () => ({
      serverURL: enviroment.alisonServerApiUrl,
      generationClientId: enviroment.alisonServerGenClientKey,
      generationClientSecret: enviroment.alisonServerGenClientSecret,
      generationGrantType: 'client_credentials',
      usageClientId: enviroment.alisonServerUseClientKey,
      usageClientSecret: enviroment.alisonServerUseClientSecret,
      usageGrantType: 'client_credentials',
      usageScope: 'seat:12345678@acme',
      seat: 'botonera',
      tenant: 'acme',
      existsGenerationToken: false,
      existsUsageToken: false,
      steps: { generation: [], usage: [] },
      logs: { generation: [], usage: [] },
      showConsole: { generation: false, usage: false },
    }),
    mounted(){
      this.existsGenerationToken = this.serverConfig?.generationAccessToken !== undefined;
      this.existsUsageToken = this.serverConfig?.usageAccessToken !== undefined;
    },
    watch:{
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      async updateGenerationToken() {
        const flow = 'generation';
        this.resetFlow(flow, [
          { key: "token", label: "Obteniendo token" },
          { key: "decode", label: "Token decodificado" },
          { key: "seat", label: "Generando/obteniendo seat" },
          { key: "store", label: "Token guardado en store" },
        ]);

        alisonServer.changeServerURL(this.serverURL);
        alisonServer.changeTenant(this.tenant);

        this.setStepStatus(flow, "token", "loading");
        this.logRequest(flow, "POST", `${this.serverURL}/oauth/token`, {
          client_id: this.generationClientId,
          client_secret: "••••••••",
          grant_type: this.generationGrantType,
        });
        let tokenResponse;
        try {
          tokenResponse = await alisonServer.updateGenerationToken(this.generationClientId, this.generationClientSecret);
          this.logResponse(flow, tokenResponse);
          this.setStepStatus(flow, "token", "success");
        } catch (e) {
          this.logResponse(flow, e?.response?.data ?? e.message ?? e, true);
          this.setStepStatus(flow, "token", "error", { message: this.classifyError(e) });
          console.log(e);
          return;
        }

        this.decodeStep(flow, tokenResponse.access_token);

        this.setStepStatus(flow, "seat", "loading");
        this.logRequest(flow, "POST", `${this.serverURL}/api/v1/seats`, { name: this.seat });
        let seatId;
        let seatName;
        try {
          const seatResponse = await alisonServer.createSeat(this.seat);
          seatId = seatResponse.id;
          seatName = seatResponse.name;
          this.logResponse(flow, seatResponse);
          this.setStepStatus(flow, "seat", "success");
        } catch (e) {
          this.logResponse(flow, e?.response?.data ?? e.message ?? e, true);
          this.setStepStatus(flow, "seat", "error", { message: this.classifyError(e) });
          console.log(e);
          return;
        }

        this.existsGenerationToken = true;
        // El scope de Usage tiene que apuntar al seat recién creado/obtenido.
        // El server puede devolver el "name" como "<seat>@<TENANT>" (ej.
        // "41999064@ACME"): el scope real es el name, no el id (UUID) interno.
        const seatLocalPart = String(seatName || this.seat).split('@')[0];
        this.usageScope = `seat:${seatLocalPart}@${this.tenant}`;
        this.$emit("setServerConfig", {
          generationAccessToken: tokenResponse.access_token,
          seatId,
          tenant: this.tenant,
          serverURL: this.serverURL,
        });
        this.setStepStatus(flow, "store", "success");
      },
      async updateUsageToken() {
        const flow = 'usage';
        this.resetFlow(flow, [
          { key: "token", label: "Obteniendo token" },
          { key: "decode", label: "Token decodificado" },
          { key: "store", label: "Token guardado en store" },
        ]);

        alisonServer.changeServerURL(this.serverURL);
        alisonServer.changeTenant(this.tenant);

        this.setStepStatus(flow, "token", "loading");
        this.logRequest(flow, "POST", `${this.serverURL}/oauth/token`, {
          client_id: this.usageClientId,
          client_secret: "••••••••",
          grant_type: this.usageGrantType,
          scope: this.usageScope,
        });
        let tokenResponse;
        try {
          tokenResponse = await alisonServer.updateUsageToken(this.usageClientId, this.usageClientSecret, this.usageScope);
          this.logResponse(flow, tokenResponse);
          this.setStepStatus(flow, "token", "success");
        } catch (e) {
          this.logResponse(flow, e?.response?.data ?? e.message ?? e, true);
          this.setStepStatus(flow, "token", "error", { message: this.classifyError(e) });
          console.log(e);
          return;
        }

        this.decodeStep(flow, tokenResponse.access_token);

        this.existsUsageToken = true;
        this.$emit("setServerConfig", {
          usageAccessToken: tokenResponse.access_token,
          tenant: this.tenant,
          serverURL: this.serverURL,
        });
        this.$emit("enableTab", ["Sign Server"]);
        this.setStepStatus(flow, "store", "success");
      },
      resetFlow(flow, defs) {
        this.steps[flow] = defs.map(def => ({ ...def, status: "pending", message: "", payload: null }));
        this.logs[flow] = [];
      },
      setStepStatus(flow, key, status, extra = {}) {
        const step = this.steps[flow].find(s => s.key === key);
        if (step) Object.assign(step, { status, ...extra });
      },
      classifyError(e) {
        const status = e?.response?.status;
        if (status === 400 || status === 401 || status === 403) return "credenciales invalidas";
        return "error inesperado";
      },
      decodeStep(flow, accessToken) {
        const payload = this.decodeJwt(accessToken);
        if (payload) {
          this.setStepStatus(flow, "decode", "success", { payload });
        } else {
          this.setStepStatus(flow, "decode", "warning", { message: "No se pudo decodificar el token" });
        }
      },
      decodeJwt(token) {
        try {
          const [, payload] = token.split(".");
          const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
          const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
          const json = decodeURIComponent(
            atob(padded)
              .split("")
              .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
              .join("")
          );
          return JSON.parse(json);
        } catch (e) {
          return null;
        }
      },
      logRequest(flow, method, url, body) {
        this.logs[flow].push({ time: new Date().toLocaleTimeString(), direction: "request", method, url, body });
      },
      logResponse(flow, body, isError = false) {
        this.logs[flow].push({ time: new Date().toLocaleTimeString(), direction: "response", body, isError });
      },
      logLine(entry) {
        if (entry.direction === "request") return `> ${entry.method} ${entry.url}`;
        return entry.isError ? "< ERROR" : "< 200";
      },
    },
  }
</script>
